import type {
  BrewerFilterProps,
  BrewerModel,
  CreateBrewerParams,
  DeleteBrewerParams,
  ListAutoCompleteBrewersResponse,
  ListBrewersResponse,
  UpdateBrewerParamsWithId
} from '../types';
import { apiDel, apiGet, apiPost, apiPut } from './api-client';
import { PaginationParams } from './params';

const apiName = 'avaniV2HttpApi';
const path = 'outer/brewers';

export const listBrewers = async (
  filters: BrewerFilterProps,
  params: PaginationParams = new PaginationParams()
): Promise<ListBrewersResponse> => {
  const { product, user, name, status, amsAgreement, maxFixes } = filters;
  return apiGet(apiName, path, {
    ...(product && { productId: product.id }),
    ...(user && { userId: user.id }),
    ...(name && { name }),
    ...(status && { status }),
    ...(amsAgreement !== undefined && { amsAgreement }),
    ...(maxFixes && { maxFixes }),
    ...params
  });
};

export const getBrewerInfo = async (brewerId: string): Promise<BrewerModel> => {
  return apiGet(apiName, `${path}/${brewerId}`);
};

export const createBrewer = async (body: CreateBrewerParams): Promise<BrewerModel> => {
  return apiPost(apiName, path, body);
};

export const updateBrewer = async (params: UpdateBrewerParamsWithId): Promise<BrewerModel> => {
  const { brewerId, ...body } = params;
  return apiPut(apiName, `${path}/${brewerId}`, body);
};

export const deleteBrewer = async (params: DeleteBrewerParams): Promise<BrewerModel> => {
  return apiDel(apiName, `${path}/${params.brewerId}`);
};

export const listBrewersAutoComplete = async (search: string): Promise<ListAutoCompleteBrewersResponse> => {
  return apiGet(apiName, `${path}/autocomplete`, { search });
};
